// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2023 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateContactIdMappingRequestModel from '../../model/update-contact-id-mapping-request-model';
import UpdateContactIdMappingRequestDTO from '../dto/update-contact-id-mapping-request-dto';

export default abstract class UpdateContactIdMappingRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateContactIdMappingRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  'id'?: number;

  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO>): UpdateContactIdMappingRequestModel;
  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO> | undefined | null): UpdateContactIdMappingRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO> | undefined | null): UpdateContactIdMappingRequestModel | undefined {
    return dto ? new UpdateContactIdMappingRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateContactIdMappingRequestModel> | UpdateContactIdMappingRequestModel) {
    const unwrapped = unwrapDataRecord(model);
    return {
      'id': unwrapped.id,
    } as UpdateContactIdMappingRequestDTO;
  }
}
